import React, { useState } from "react";
import { Button, Container } from "reactstrap";
import styles from "../../styles/public/calendar.module.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const Calendar = ({ selectedDate, maxDate = new Date(8640000000000000), onDateSelect, prices, onMonthChange }) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const [currentDate, setCurrentDate] = useState(selectedDate || new Date());

  const daysOfWeek = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]; // Start with Monday

  const getDaysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();

  const getFirstDayOfMonth = (year, month) => {
    const day = new Date(year, month, 1).getDay(); // 0=Sun, 1=Mon, ..., 6=Sat
    return (day + 6) % 7; // Shift: 0=Mon, 1=Tue, ..., 6=Sun
  };

  const generateCalendarDays = (year, month) => {
    const daysInMonth = getDaysInMonth(year, month);
    const firstDay = getFirstDayOfMonth(year, month);
    const calendarDays = [];
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    for (let day = 1; day <= daysInMonth; day++) {
      let price = null;
      const fullDate = new Date(year, month, day);
      fullDate.setHours(0, 0, 0, 0);
      const isDisabled = fullDate < today || fullDate > maxDate;
      const column = (firstDay + (day - 1)) % 7; // 0=Mon, 1=Tue, ..., 6=Sun

      if (!isDisabled) {
        // find price from prices array
        const dateStr = fullDate.toISOString().split('T')[0];
        const priceData = prices.find(p => p.date === dateStr);
        price = priceData?.price || null;
      }

      calendarDays.push({ day, price, disabled: isDisabled, fullDate, column })
    }
    return calendarDays;
  };

  const handleDayClick = (day) => onDateSelect(day.fullDate);

  const handleNextMonth = () => {
    const newDate = new Date(currentDate);
    newDate.setMonth(newDate.getMonth() + 1);
    setCurrentDate(newDate);
    onMonthChange(newDate);
  };

  const handlePrevMonth = () => {
    const newDate = new Date(currentDate);
    newDate.setMonth(newDate.getMonth() - 1);
    setCurrentDate(newDate);
    onMonthChange(newDate);
  };

  const calendarDays = generateCalendarDays(currentDate.getFullYear(), currentDate.getMonth());
  const firstDayOffset = getFirstDayOfMonth(currentDate.getFullYear(), currentDate.getMonth());

  return (
    <Container className={`${styles["calendar-container"]} p-3 m-auto border rounded`}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <Button
          color="link"
          className={`${styles["nav-button"]} ${currentDate.getMonth() === new Date().getMonth() && currentDate.getFullYear() === new Date().getFullYear() ? "disabled" : ""}`}
          onClick={handlePrevMonth}
          disabled={currentDate.getMonth() === new Date().getMonth() && currentDate.getFullYear() === new Date().getFullYear()}
        >
          <FaChevronLeft /> Prev <span className={styles["month-text"]}>Month</span>
        </Button>
        <h2 className="m-0">
          {currentDate.toLocaleString("default", { month: "long", year: "numeric" })}
        </h2>
        <Button
          color="link"
          className={styles["nav-button"]}
          onClick={handleNextMonth}
        >
          Next <span className={styles["month-text"]}>Month</span> <FaChevronRight />
        </Button>
      </div>

      <div className={`${styles["days-of-week"]} mb-2`}>
        {daysOfWeek.map((day, index) => (
          <span key={index} className="text-center fw-medium text-dark d-block">
            {day}
          </span>
        ))}
      </div>

      <div className={`${styles["calendar-grid"]} mb-3`}>
        {Array.from({ length: 42 }, (_, i) => {
          const dayIndex = i - firstDayOffset;
          const day = calendarDays[dayIndex];
          return (
            <div key={i} className={styles["calendar-cell"]}>
              {day ? (
                <Button
                  color="light"
                  className={`${styles["day-button"]} ${
                    selectedDate && selectedDate.toDateString() === day.fullDate.toDateString()
                      ? styles.selected
                      : ""
                  } ${day.disabled ? "disabled" : ""}`}
                  onClick={() => handleDayClick(day)}
                  disabled={day.disabled}
                >
                  <span className={styles["calendar-date"]}>{day.day}</span>
                  <span className={styles["calendar-price"]}>
                    {day.price !== null
                      ? day.price : prices.length > 0 ? '' : '...'}
                  </span>
                </Button>
              ) : null}
            </div>
          );
        })}
      </div>
    </Container>
  );
};

export default Calendar;